/* Offer page (templates/product.offer.json): configurator, tabs, FAQ, video, scroll-CTA's, sticky balk,
   review-rotatie, klantverhalen-carrousel en preloading van productfoto's. Alleen geladen door layout/offer.liquid. */
(function () {
  'use strict';
  // Vertaalde strings uit layout/offer.liquid (window.DFL.offer.i18n); fallback = NL.
  function t(key, fallback) {
    var o = (window.DFL && window.DFL.offer && window.DFL.offer.i18n) || {};
    return o[key] || fallback;
  }
  var cfg = (window.DFL && window.DFL.offer) || {};
  var root = cfg.root || '/';

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function thumbUrl(src) { return src.replace(/width=\d+/, 'width=300'); }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollToTarget(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Scroll-CTA's en interne links (knoppen, reviewpill, mini-review) ---------- */
  qsa('[data-ofr-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || a.getAttribute('data-ofr-scroll') || '';
      if (href.charAt(0) !== '#') return;
      var target = qs(href);
      if (!target) return;
      e.preventDefault();
      scrollToTarget(target);
      try { window.clarity && window.clarity('event', a.classList.contains('ofr-btn') ? 'offer_scroll_cta' : 'offer_scroll_reviews'); } catch (err) {}
    });
    if (a.tagName !== 'A' && a.tagName !== 'BUTTON') {
      a.setAttribute('role', 'link'); a.setAttribute('tabindex', '0');
      a.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); a.click(); } });
    }
  });

  /* ---------- FAQ ---------- */
  qsa('[data-ofr-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ofr-faq-item');
      var answer = qs('.ofr-faq-a', item);
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (answer) answer.hidden = !open;
    });
  });

  /* ---------- Formaat-tabs ---------- */
  qsa('[data-ofr-tabs]').forEach(function (wrap) {
    var tabs = qsa('[data-ofr-tab]', wrap);
    var panels = qsa('[data-ofr-tab-panel]', wrap);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-ofr-tab');
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { var on = p.getAttribute('data-ofr-tab-panel') === idx; p.classList.toggle('is-active', on); p.hidden = !on; });
      });
    });
  });

  /* ---------- Video ---------- */
  qsa('[data-ofr-video]').forEach(function (box) {
    var play = qs('[data-ofr-video-play]', box);
    var poster = qs('[data-ofr-video-poster]', box);
    var native = qs('.ofr-video-native', box);
    var url = box.getAttribute('data-video-url') || '';
    if (!play) return;
    play.addEventListener('click', function () {
      if (native) {
        native.hidden = false;
        poster.hidden = true;
        var v = qs('video', native);
        if (v) { try { v.play(); } catch (e) {} }
        return;
      }
      if (!url) return;
      var embed = '';
      var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (yt) embed = 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      if (!embed) return;
      var iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('title', t('video', 'Video'));
      iframe.className = 'ofr-video-iframe';
      poster.replaceWith(iframe);
    });
  });

  /* ---------- Klantverhalen: stipjes bij de swipe-carrousel (mobiel) ---------- */
  qsa('[data-ofr-testi]').forEach(function (grid) {
    var cards = qsa('.ofr-testi-card', grid);
    var dotsWrap = qs('[data-ofr-dots]', grid.parentNode);
    if (!dotsWrap || cards.length < 2) return;
    dotsWrap.hidden = false;
    var dots = cards.map(function (card, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'ofr-dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', t('storyXofY', 'Verhaal {{ index }} van {{ total }}').replace('{{ index }}', i + 1).replace('{{ total }}', cards.length));
      d.addEventListener('click', function () { grid.scrollTo({ left: card.offsetLeft - grid.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      dotsWrap.appendChild(d);
      return d;
    });
    var ticking = false;
    grid.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var mid = grid.scrollLeft + grid.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) { var center = c.offsetLeft - grid.offsetLeft + c.offsetWidth / 2; var dist = Math.abs(center - mid); if (dist < bestDist) { bestDist = dist; best = i; } });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      });
    }, { passive: true });
  });

  /* ---------- Review-rotatie (mini-reviews naast de galerij) ---------- */
  qsa('[data-ofr-reviews]').forEach(function (box) {
    var items = qsa('.ofr-minireview-item', box);
    if (items.length < 2) return;
    var interval = (parseInt(box.getAttribute('data-interval'), 10) || 7) * 1000;
    var i = Math.floor(Math.random() * items.length);
    function show(n) { items.forEach(function (el, j) { el.hidden = j !== n; }); }
    show(i);
    if (reduceMotion) return;
    var timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, interval);
    box.addEventListener('mouseenter', function () { clearInterval(timer); });
    box.addEventListener('mouseleave', function () { timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, interval); });
  });

  /* ---------- Configurator ---------- */
  var section = qs('[data-ofr-configurator]');
  /* Sleutel van de variant voor orderattribuut en Clarity: de template-suffix (offer, offer-b, ...) */
  var layoutKey = (section && section.getAttribute('data-ofr-layout')) || 'offer';
  if (!section) return;

  var products = [];
  var conf = {};
  try { products = JSON.parse(qs('[data-ofr-products]', section).textContent || '[]'); } catch (e) { products = []; }
  try { conf = JSON.parse(qs('[data-ofr-config]', section).textContent || '{}'); } catch (e) { conf = {}; }
  var storageNotes = {};
  (conf.storageNotes || '').split(/\r?\n/).forEach(function (line) {
    var parts = line.split('|');
    if (parts[0] && parts[0].trim()) storageNotes[parts[0].trim().toLowerCase()] = (parts[1] || '').trim();
  });
  var formatKeys = conf.formats || {};

  var els = {
    formatCards: qsa('[data-ofr-format]', section),
    swatches: qs('[data-ofr-swatches]', section),
    colorName: qs('[data-ofr-color-name]', section),
    colorStep: qs('[data-ofr-color-step]', section),
    storage: qs('[data-ofr-storage]', section),
    storageStep: qs('[data-ofr-storage-step]', section),
    total: qs('[data-ofr-total]', section),
    totalSticky: qs('[data-ofr-total-sticky]'),
    variantInput: qs('[data-ofr-variant-id]', section),
    form: qs('[data-ofr-form]', section),
    addBtn: qs('[data-ofr-add]', section),
    addLabel: qs('[data-ofr-add-label]', section),
    error: qs('[data-ofr-error]', section),
    mainImg: qs('[data-ofr-main-img]', section),
    thumbs: qs('[data-ofr-thumbs]', section),
    thumbPrev: qs('[data-ofr-thumb-prev]', section),
    thumbNext: qs('[data-ofr-thumb-next]', section),
    qtyInput: qs('[data-ofr-qty-input]', section),
    qtyValue: qs('[data-ofr-qty-value]', section),
    qtyMinus: qs('[data-ofr-qty-minus]', section),
    qtyPlus: qs('[data-ofr-qty-plus]', section)
  };
  var qty = 1;
  function setQty(n) {
    qty = Math.max(1, Math.min(10, n));
    if (els.qtyValue) els.qtyValue.textContent = qty;
    if (els.qtyInput) els.qtyInput.value = qty;
    if (els.qtyMinus) els.qtyMinus.disabled = qty <= 1;
    if (els.qtyPlus) els.qtyPlus.disabled = qty >= 10;
    renderTotal();
  }
  if (els.qtyMinus) els.qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
  if (els.qtyPlus) els.qtyPlus.addEventListener('click', function () { setQty(qty + 1); });
  var defaultAddLabel = els.addLabel ? els.addLabel.textContent : '';
  var state = { formaat: null, kleur: null, product: null, variant: null, imageIndex: 0 };

  /* --- preloading: eerste foto + thumbs van elk product na de eerste paint, alle foto's van het gekozen product en bij hover --- */
  var preloaded = {};
  function preload(src) {
    if (!src || preloaded[src]) return;
    preloaded[src] = true;
    var im = new Image();
    im.decoding = 'async';
    im.src = src;
  }
  function preloadProduct(p, full) {
    if (!p || !p.images) return;
    p.images.forEach(function (src, i) { preload(thumbUrl(src)); if (full || i === 0) preload(src); });
  }
  function preloadAll() {
    products.forEach(function (p) { preloadProduct(p, false); });
    setTimeout(function () { products.forEach(function (p) { preloadProduct(p, true); }); }, 4000);
  }
  if (document.readyState === 'complete') idle(preloadAll); else window.addEventListener('load', function () { idle(preloadAll); });

  function productsFor(formaat) { return products.filter(function (p) { return p.formaat === formaat; }); }
  function minPrice(list) {
    var min = null;
    list.forEach(function (p) { p.variants.forEach(function (v) { if (min === null || v.price < min) min = v.price; }); });
    return min;
  }
  function pickProduct(formaat, kleur) {
    var list = productsFor(formaat);
    if (!list.length) return null;
    var byColor = kleur ? list.filter(function (p) { return p.kleur === kleur; })[0] : null;
    if (byColor) return byColor;
    var def = list.filter(function (p) { return p.isDefault; })[0];
    if (def) return def;
    var avail = list.filter(function (p) { return p.available; })[0];
    return avail || list[0];
  }
  function pickVariant(product, storageValue) {
    if (!product) return null;
    var vs = product.variants;
    if (storageValue) {
      var m = vs.filter(function (v) { return (v.storage || '').toLowerCase() === storageValue.toLowerCase(); })[0];
      if (m) return m;
    }
    return vs.filter(function (v) { return v.available; })[0] || vs[0] || null;
  }

  /* --- render --- */
  function renderFormats() {
    els.formatCards.forEach(function (card) {
      var f = card.getAttribute('data-ofr-format');
      var list = productsFor(f);
      var priceEl = qs('[data-ofr-format-price]', card);
      var stockEl = qs('[data-ofr-format-stock]', card);
      var on = f === state.formaat;
      card.classList.toggle('is-active', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      if (!list.length) { card.classList.add('is-unavailable'); card.disabled = true; if (priceEl) priceEl.textContent = ''; return; }
      /* prijs en foto volgen de gekozen kleur (of het standaardproduct van dit formaat) */
      var rep = pickProduct(f, state.kleur);
      /* ...en de gekozen opslag: de kaart toont de prijs van die variant (of de laagste prijs als het formaat die opslag niet kent) */
      var storageKey = state.variant && state.variant.storage ? state.variant.storage : null;
      var repVariant = (rep && storageKey) ? pickVariant(rep, storageKey) : null;
      var price = repVariant ? repVariant.price : (rep ? minPrice([rep]) : minPrice(list));
      if (priceEl) priceEl.textContent = price !== null ? money(price) : '';
      var anyAvailable = list.some(function (p) { return p.available; });
      card.classList.toggle('is-soldout', !anyAvailable);
      if (stockEl) stockEl.hidden = anyAvailable;
      var autoImg = qs('[data-ofr-format-img-auto]', card);
      if (autoImg && rep && rep.images && rep.images[0]) {
        var src = rep.images[0].replace(/width=\d+/, 'width=400');
        if (autoImg.getAttribute('src') !== src) autoImg.src = src;
      }
    });
  }
  function renderSwatches() {
    if (!els.swatches) return;
    var list = productsFor(state.formaat);
    els.swatches.innerHTML = '';
    if (els.colorStep) els.colorStep.hidden = list.length <= 1 && !(list[0] && list[0].kleurLabel);
    list.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ofr-swatch' + (p.kleur === state.kleur ? ' is-active' : '') + (p.available ? '' : ' is-soldout');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', p.kleur === state.kleur ? 'true' : 'false');
      b.setAttribute('aria-label', p.kleurLabel + (p.available ? '' : ' (' + (conf.soldOutLabel || t('soldOut', 'uitverkocht')) + ')'));
      b.title = p.kleurLabel + (p.available ? '' : ' (' + (conf.soldOutLabel || t('soldOut', 'uitverkocht')) + ')');
      b.style.background = p.hex || '#1e1e1e';
      b.addEventListener('click', function () { select(state.formaat, p.kleur, null); });
      b.addEventListener('mouseenter', function () { preloadProduct(p, true); });
      els.swatches.appendChild(b);
    });
    if (els.colorName) els.colorName.textContent = state.product ? state.product.kleurLabel : '';
  }
  function renderStorage() {
    if (!els.storage) return;
    els.storage.innerHTML = '';
    var p = state.product;
    if (!p) return;
    var hasStorage = !!p.storageOption;
    var fixed = !hasStorage && p.storageFixed;
    if (els.storageStep) els.storageStep.hidden = !hasStorage && !fixed;
    if (!hasStorage && !fixed) return;
    if (fixed) {
      var f = document.createElement('div');
      f.className = 'ofr-storage-card is-active is-fixed';
      var fnote = storageNotes[String(p.storageFixed).toLowerCase()] || '';
      f.innerHTML = '<span class="ofr-storage-name">' + esc(p.storageFixed) + '</span>' + (fnote ? '<span class="ofr-storage-note">' + esc(fnote) + '</span>' : '') + '<span class="ofr-storage-tag">' + esc(conf.includedLabel) + '</span>';
      els.storage.appendChild(f);
      return;
    }
    p.variants.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ofr-storage-card' + (state.variant && v.id === state.variant.id ? ' is-active' : '') + (v.available ? '' : ' is-soldout');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', state.variant && v.id === state.variant.id ? 'true' : 'false');
      var note = storageNotes[(v.storage || '').toLowerCase()] || '';
      b.innerHTML = '<span class="ofr-storage-name">' + esc(v.storage) + '</span>' +
        (note ? '<span class="ofr-storage-note">' + esc(note) + '</span>' : '') +
        '<span class="ofr-storage-tag">' + esc(v.available ? (i === 0 ? conf.includedLabel : conf.upgradeLabel) : conf.soldOutLabel) + '</span>';
      b.addEventListener('click', function () { state.variant = v; renderStorage(); renderFormats(); renderTotal(); syncUrl(); });
      els.storage.appendChild(b);
    });
  }
  function renderTotal() {
    var v = state.variant;
    var txt = v ? money(v.price * qty) : '';
    if (els.total) els.total.textContent = txt;
    if (els.totalSticky) els.totalSticky.textContent = txt;
    if (els.variantInput) els.variantInput.value = v ? v.id : '';
    if (els.addBtn) {
      var ok = !!(v && v.available);
      els.addBtn.disabled = !ok;
      if (els.addLabel) els.addLabel.textContent = ok ? defaultAddLabel : (conf.soldOutLabel || defaultAddLabel);
    }
  }
  function renderGallery() {
    var p = state.product;
    if (!p || !els.thumbs) return;
    var imgs = p.images && p.images.length ? p.images : [];
    els.thumbs.innerHTML = '';
    if (!imgs.length) return;
    state.imageIndex = Math.min(state.imageIndex, imgs.length - 1);
    imgs.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ofr-thumb' + (i === state.imageIndex ? ' is-active' : '');
      b.setAttribute('aria-label', t('photoXofY', 'Foto {{ index }} van {{ total }}').replace('{{ index }}', i + 1).replace('{{ total }}', imgs.length));
      var im = document.createElement('img');
      im.src = thumbUrl(src);
      im.alt = '';
      im.decoding = 'async';
      im.width = 122; im.height = 122;
      b.appendChild(im);
      b.addEventListener('click', function () { showImage(i); });
      b.addEventListener('mouseenter', function () { preload(src); });
      els.thumbs.appendChild(b);
    });
    showImage(state.imageIndex, true);
  }
  /* Niet-rondlopend: pijlen tonen actief/inactief; de thumbnailstrook schuift mee met de gekozen foto. */
  function showImage(i, instant) {
    var p = state.product;
    if (!p || !p.images.length) return;
    var n = p.images.length;
    state.imageIndex = Math.max(0, Math.min(n - 1, i));
    if (els.mainImg) els.mainImg.src = p.images[state.imageIndex];
    var thumbs = qsa('.ofr-thumb', els.thumbs);
    thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === state.imageIndex); });
    var active = thumbs[state.imageIndex];
    if (active && els.thumbs) {
      var left = active.offsetLeft - els.thumbs.offsetLeft;
      var visibleStart = els.thumbs.scrollLeft, visibleEnd = visibleStart + els.thumbs.clientWidth;
      if (left < visibleStart || left + active.offsetWidth > visibleEnd) {
        els.thumbs.scrollTo({ left: Math.max(0, left - (els.thumbs.clientWidth - active.offsetWidth) / 2), behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
      }
    }
    if (els.thumbPrev) els.thumbPrev.disabled = state.imageIndex <= 0;
    if (els.thumbNext) els.thumbNext.disabled = state.imageIndex >= n - 1;
  }
  if (els.thumbPrev) els.thumbPrev.addEventListener('click', function () { showImage(state.imageIndex - 1); });
  if (els.thumbNext) els.thumbNext.addEventListener('click', function () { showImage(state.imageIndex + 1); });

  function select(formaat, kleur, storageValue) {
    var prod = pickProduct(formaat, kleur);
    if (!prod) return;
    var keepStorage = storageValue || (state.variant ? state.variant.storage : null);
    state.formaat = formaat;
    state.product = prod;
    state.kleur = prod.kleur;
    state.variant = pickVariant(prod, keepStorage);
    state.imageIndex = 0;
    renderFormats(); renderSwatches(); renderStorage(); renderTotal(); renderGallery(); syncUrl();
    preloadProduct(prod, true);
  }

  /* --- URL sync (?formaat=10.1&kleur=zwart&opslag=32gb) --- */
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function keyToFormat(key) {
    key = norm(key);
    if (!key) return null;
    for (var f in formatKeys) { if (formatKeys[f] && norm(formatKeys[f]) === key) return f; }
    return null;
  }
  function syncUrl() {
    if (!window.history || !window.history.replaceState || !state.product) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('formaat', formatKeys[state.formaat] || state.formaat);
      u.searchParams.set('kleur', state.kleur || '');
      if (state.variant && state.variant.storage) u.searchParams.set('opslag', String(state.variant.storage).toLowerCase()); else u.searchParams.delete('opslag');
      window.history.replaceState(null, '', u.toString());
    } catch (e) {}
  }

  els.formatCards.forEach(function (card) {
    card.addEventListener('click', function () { if (!card.disabled) select(card.getAttribute('data-ofr-format'), state.kleur, null); });
    card.addEventListener('mouseenter', function () { productsFor(card.getAttribute('data-ofr-format')).forEach(function (p) { preloadProduct(p, true); }); });
  });

  /* --- initial state --- */
  (function init() {
    if (!products.length) return;
    var params = new URLSearchParams(window.location.search);
    var f = keyToFormat(params.get('formaat'));
    var k = norm(params.get('kleur')) || null;
    var s = params.get('opslag') || null;
    if (!f) {
      var def = products.filter(function (p) { return p.isDefault; })[0] || products[0];
      f = def.formaat;
      if (!k) k = def.kleur;
    }
    select(f, k, s);
    setQty(1);
  })();

  /* --- bestellen ---
     checkout: cart-permalink (/cart/<variant>:<aantal>) → nieuwe checkout met alléén dit product,
               eerder toegevoegde artikelen uit testsessies komen niet mee.
     cart:     toevoegen via add.js en naar de winkelwagen.
     stay:     toevoegen en op de pagina blijven. */
  if (els.form) {
    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = state.variant;
      if (!v || !v.available) return;
      var mode = section.getAttribute('data-after-add') || 'cart';
      var configStr = (formatKeys[state.formaat] || state.formaat) + ' / ' + (state.product.kleurLabel || '') + ' / ' + (v.storage || state.product.storageFixed || '-');
      els.addBtn.disabled = true;
      if (els.addLabel) els.addLabel.textContent = conf.addingLabel || '…';
      if (els.error) els.error.hidden = true;
      try { window.clarity && window.clarity('event', 'offer_add_to_cart'); } catch (err) {}

      if (mode === 'checkout') {
        var permalink = root + 'cart/' + v.id + ':' + qty + '?attributes[_pdp_layout]=' + encodeURIComponent(layoutKey) + '&attributes[_pdp_config]=' + encodeURIComponent(configStr);
        window.location.href = permalink;
        return;
      }
      var attrs = { '_pdp_layout': layoutKey, '_pdp_config': configStr };
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
        })
        .then(function () {
          if (els.addLabel) els.addLabel.textContent = conf.addedLabel || defaultAddLabel;
          if (mode === 'cart') window.location.href = cfg.cartUrl || (root + 'cart');
          else { els.addBtn.disabled = false; setTimeout(function () { if (els.addLabel) els.addLabel.textContent = defaultAddLabel; }, 2000); }
        })
        .catch(function () {
          els.addBtn.disabled = false;
          if (els.addLabel) els.addLabel.textContent = defaultAddLabel;
          if (els.error) { els.error.textContent = conf.errorLabel || t('error', 'Er ging iets mis.'); els.error.hidden = false; }
        });
    });
  }

  try { window.clarity && window.clarity('set', 'pdp_layout', layoutKey); } catch (e) {}

  /* --- sticky balk (mobiel): zichtbaar zodra de hero voorbij is en de configurator niet in beeld is;
         Cookiebot-knop en WebwinkelKeur-badge worden via een body-class omhoog getild --- */
  var sticky = qs('[data-ofr-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var configVisible = false, heroPassed = false;
    var hero = qs('.ofr-hero');
    function update() {
      var show = heroPassed && !configVisible;
      sticky.hidden = !show;
      document.body.classList.toggle('ofr-sticky-visible', show && window.innerWidth <= 900);
    }
    new IntersectionObserver(function (entries) { configVisible = entries[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(section);
    if (hero) new IntersectionObserver(function (entries) { heroPassed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; update(); }, { threshold: 0 }).observe(hero);
    else heroPassed = true;
    window.addEventListener('resize', update);
  }
})();
